import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43d994b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-down el-icon--right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTree = _resolveComponent("BaseTree")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    placement: "bottom-start",
    disabled: _ctx.disabled,
    trigger: "click",
    width: "auto",
    "popper-class": "group-tree-selector-popover el-card"
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        size: "small",
        class: _normalizeClass(["reference-button", [_ctx.customClass, { active: _ctx.visible,disabled:_ctx.disabled }]]),
        style: _normalizeStyle(_ctx.style)
      }, [
        _createElementVNode("span", {
          class: "text",
          title: _ctx.selectedGroup.name + '(' + _ctx.selectedGroup.total + ')'
        }, _toDisplayString(_ctx.selectedGroup.name + '(' + _ctx.selectedGroup.total + ')'), 9, _hoisted_1),
        _hoisted_2
      ], 6)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_BaseTree, {
        class: "base-tree",
        "show-header": false,
        isBorder: false,
        terminalType: _ctx.terminalType,
        subnet_address: _ctx.subnet_address,
        "filter-empty-group": _ctx.filterEmptyGroup,
        "disabled-ids": _ctx.disabledIds,
        "default-group-id": _ctx.defaultGroupId,
        onTerminalGroupSelected: _ctx.clickNode
      }, null, 8, ["terminalType", "subnet_address", "filter-empty-group", "disabled-ids", "default-group-id", "onTerminalGroupSelected"])
    ]),
    _: 1
  }, 8, ["visible", "disabled"]))
}